import { tv } from "tailwind-variants";

/** Generates classes for a tree item. Looks like the first, middle, or last item in a visual grouping that looks like a tile. */
export const treeItem = tv({
  base: "group overflow-hidden border-t border-r border-l border-border-light bg-white aria-[level=1]:mt-2 aria-[level=1]:rounded-t-lg aria-[level=1]:aria-[posinset=1]:mt-0 data-[react-aria-pressable]:cursor-pointer data-[react-aria-pressable]:hover:bg-blue-50 selected:bg-blue-100 drop-target:bg-purple-100",
  variants: {
    isLastItemAtLevel: {
      // This is the last item of a visual grouping if it's the last item at this level (the last child of its parent) and it's not expanded (in which case there are grandchildren below).
      true: "rounded-b-lg border-b aria-[expanded=true]:rounded-b-none aria-[expanded=true]:border-b-0",
    },
  },
});

/** Generates classes for the inside of an "add" CTA tree item. */
export const addActionItemContent = tv({
  base: "flex cursor-pointer items-center gap-5 px-5 py-2 text-sm font-semibold text-blue-600 hover:bg-blue-50",
});
